module.exports = __webpack_public_path__ + "static/media/hit-btc-logo.3d6c08a5.png";